import { IconBarChartRed, IconCirkularRed, IconGlobeRed } from '../assets/icons';

const UspData = [
  {
    icon: IconGlobeRed,
    heading: 'Klimatsmarta\ntransporter',
    text: 'Förnybara energikällor och optimerade\nrutter minimerar koldioxidutsläpp',
  },
  {
    icon: IconCirkularRed,
    heading: 'Optimerad\navfallshantering',
    text: 'Kostnadseffektiva lösningar som minskar\nmiljöpåverkan och stöttar cirkulär ekonomi',
  },
  {
    icon: IconBarChartRed,
    heading: 'Digitala\nlösningar',
    text: 'Transparens varar längst! Följ upp och hantera er\nåtervinning med vår kundportal och app',
  },
];

export default UspData;
